export const recentTimeRange = (minutes: number, now = new Date()) => ({
  start: new Date(now.getTime() - minutes * 60 * 1000),
  end: new Date(now.getTime()),
});
